import { Component, HostListener } from '@angular/core';
import { WindowRef } from 'src/app/window';
import { scrollBehavior } from 'src/app/shared/utils/reduced-motion';

@Component({
  selector: 'app-back-top-button',
  templateUrl: './back-top-button.component.html',
  styleUrls: ['./back-top-button.component.scss']
})
export class BackTopButtonComponent {

  windowScrolled!: boolean;

  @HostListener('window:scroll', ['$event']) onWindowScroll() {
      if (window.pageYOffset > 200) {
        this.windowScrolled = true;
      }
      if (this.windowScrolled && window.pageYOffset < 180) {
        this.windowScrolled = false;
      }
  }
  constructor(private winRef: WindowRef) { }
  gotoTop() {
    this.winRef.nativeWindow.scroll({
      top: 0,
      left: 0,
      // The user's own answer, not a fixed 'smooth'. A scroll asked for in JavaScript takes its
      // behaviour from this argument rather than from the cascade, so the universal
      // `prefers-reduced-motion` reset in styles.scss does not reach it -- see reduced-motion.ts.
      behavior: scrollBehavior(this.winRef.nativeWindow)
    });
  }

}
